import { USER_AGENT_DEV_MODE_TOKEN } from '~/constants';
import { useAppInfoStore } from '~/store';

/**
 * @description 유저 에이전트 정보 조회
 */
export const useUserAgent = () => {
  const appType = useAppInfoStore.getState().appType;

  const isDevMode = navigator.userAgent === USER_AGENT_DEV_MODE_TOKEN;

  const isIos = appType === 'ios' || !!window.webkit;
  const isAndroid = appType === 'android' || !!window.JSBridge;

  const isWebView = appType !== null && (isIos || isAndroid);
  return { isIos, isAndroid, isWebView, isDevMode };
};
